const headerCache = new WeakMap<HTMLTableElement, string[]>();

function headerLabels(table: HTMLTableElement): string[] {
  let labels = headerCache.get(table);
  if (!labels) {
    labels = Array.from(table.querySelectorAll("thead th")).map((th) => th.textContent?.trim() ?? "");
    headerCache.set(table, labels);
  }
  return labels;
}

/**
 * Stamps each top-level `<td>` in `row` with a `data-label` attribute taken from `table`'s
 * `<thead>` text (by column index). Below the mobile breakpoint, `.data-table` CSS stacks rows
 * into a flow layout and renders these via `td::before { content: attr(data-label) }` — the
 * single systemic mechanism for every current and future data table (docs/design/04-frontend.md
 * "Responsive tables"). Columns with no header text (e.g. a trailing actions column) are left
 * unlabelled on purpose, so no empty label renders.
 */
export function labelRow(row: Element, table: HTMLTableElement): Element {
  const labels = headerLabels(table);
  const cells = row.querySelectorAll(":scope > td");
  cells.forEach((td, i) => {
    if (labels[i]) td.setAttribute("data-label", labels[i]);
  });
  return row;
}
